export default __webpack_public_path__ + "static/media/pic7-1.d369ae7b.jpg";